import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.parse-float.js";
import "core-js/modules/es.number.constructor.js";
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency, getSchoolCommissionsLink, useEventTracker } from '@applyboard/ui-utils';
import { Accordion, Box, Chip, Link as ABLink, SectionSpacer, Typography } from '@applyboard/ui-components';
export var DISCLAIMER_TEXT = "This is a high-level estimate of what may be receivable by you upon a school confirming successful full-time enrollment. This estimate uses the gross tuition amount posted on the school program page, however, the actual commission you may receive is based on a final determination resulting from ApplyBoard's agreement with the school, the net amount payable to ApplyBoard after deducting ancillary fees, scholarships and/or other non-commissionable fees. The commission is subject to several variables relevant to each student, such as ESL courses, nationality, volume of credits/courses, transfer policy (if any), agent change (if any), and the term and/or program. For further specific commission details, consult each student's ApplyBoard application page, specifically the Notes tab.";
function CommissionInfoSection(_ref) {
  var title = _ref.title,
    body = _ref.body;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "section",
    style: {
      textTransform: 'uppercase'
    }
  }, title), /*#__PURE__*/React.createElement(Typography, {
    mt: 1,
    variant: "legal"
  }, body));
}
function AccordionContent(_ref2) {
  var amount = _ref2.amount,
    description = _ref2.description,
    schoolCommissionsPath = _ref2.schoolCommissionsPath,
    renderCommission = _ref2.renderCommission,
    onNavigateToSchoolCommissions = _ref2.onNavigateToSchoolCommissions;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionSpacer, null, renderCommission && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    "data-testid": "commissions_commission-container",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Chip, {
    color: "positive",
    border: false
  }, amount ? "Up to ".concat(amount) : 'Unknown')), !!description && /*#__PURE__*/React.createElement(CommissionInfoSection, {
    title: "Commission Breakdown",
    body: description
  }), /*#__PURE__*/React.createElement(CommissionInfoSection, {
    title: "Disclaimer",
    body: DISCLAIMER_TEXT
  })), schoolCommissionsPath && /*#__PURE__*/React.createElement(ABLink, {
    display: "block",
    component: Link,
    to: schoolCommissionsPath,
    onClick: onNavigateToSchoolCommissions
  }, "Go to school commissions table.")));
}
export function isZeroCommission(commission) {
  return !!commission && Number.parseFloat(commission) === 0.0;
}
export function formatCommission(commission, currency) {
  var commissionText = commission.percentage ? "".concat(commission.percentage, "% of Net Tuition") : formatCurrency(commission.amount, currency);
  var commissionAvailable = !isZeroCommission(commission.percentage || commission.amount);
  return {
    commissionText: commissionText,
    commissionAvailable: commissionAvailable
  };
}
export function Commissions(_ref3) {
  var commission = _ref3.commission,
    currency = _ref3.currency,
    role = _ref3.role;
  var formattedCommission = commission && formatCommission(commission, currency);
  var schoolCommissionsPath = getSchoolCommissionsLink(role);
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var trackNavigateEvent = useCallback(function () {
    return trackEvent({
      event: "Programs Page - Clicked 'Go To School Commissions Table'"
    });
  }, [trackEvent]);
  var trackCommissionsDropdownClicked = useCallback(function () {
    return trackEvent({
      event: 'Programs Page - Clicked Commissions Drop-Down'
    });
  }, [trackEvent]);
  return /*#__PURE__*/React.createElement(Accordion, {
    onToggleOpen: trackCommissionsDropdownClicked,
    items: [{
      title: 'Commissions',
      content: /*#__PURE__*/React.createElement(AccordionContent, {
        renderCommission: !!(formattedCommission !== null && formattedCommission !== void 0 && formattedCommission.commissionAvailable),
        amount: formattedCommission === null || formattedCommission === void 0 ? void 0 : formattedCommission.commissionText,
        description: commission === null || commission === void 0 ? void 0 : commission.description,
        schoolCommissionsPath: schoolCommissionsPath,
        onNavigateToSchoolCommissions: trackNavigateEvent
      }),
      expanded: true
    }]
  });
}